const config = {
  text: {
    noise: 18,
    blurX: 5,
    blurY: 5,
    pixelSize: 10,
    duration: 1.5,
  }
}

export default config;



// WEBPACK FOOTER //
// ./app/frontend/components/animations/lighting/config.js